/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { useCallback, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Select } from '../../../../common/components';
import { Trust, trustAgreementTypes } from '../../../../constants/trust';

const initialFilters = {
  Trust: Trust[0],
  agreementTypes: trustAgreementTypes[0],
};
const TrustTypes = ({ setShowTable, setApplyFilters, report }) => {
  const [filters, setFilters] = useState(initialFilters);
  const handleFilters = (filterType, value) => {
    setApplyFilters(true);
    setFilters({
      ...filters,
      [filterType]: value,
    });
  };

  const handleTrustAccountSelect = useCallback(
    (val) => {
      const { value } = val || {};
      if (value >= 0) setShowTable((data) => ({ ...data, trustType: value }));
      if (report === 'trustItems') setApplyFilters(true);
      handleFilters('Trust', val);
    },
    [setShowTable, handleFilters, report, setApplyFilters],
  );

  const handleNeedTypeSelect = useCallback(
    (val) => {
      const { value } = val || {};
      if (value >= 0) setShowTable((data) => ({ ...data, needType: value }));
      if (report === 'trustItems') setApplyFilters(true);
      handleFilters('agreementTypes', val);
    },
    [report, setApplyFilters, setShowTable, handleFilters],
  );

  return (
    <div className="account-trust">
      <Row className="trust-type ">
        <Col lg={4} md={6}>
          <Select
            name="Trust"
            formInput={false}
            label="Trust"
            classNamePrefix="select-dropdown"
            onChange={handleTrustAccountSelect}
            value={filters.Trust}
            options={Trust}
            placeholder="Enter Trust name"
            size="sm"
          />
        </Col>

        <Col lg={4} md={6}>
          <Select
            name="agreementTypes"
            formInput={false}
            classNamePrefix="select-dropdown"
            label="Agreement Type"
            onChange={handleNeedTypeSelect}
            value={filters.agreementTypes}
            options={trustAgreementTypes}
            placeholder="Enter agreement type"
            size="sm"
          />
        </Col>
      </Row>
      <hr />
    </div>
  );
};
export default TrustTypes;
